<div class="content-layout left-sidebar-fullheight-basic-inner-scroll">
  <research-filters
    [isQuerying]="loadingMarkers$ | async"
    [showGetLocation]="userHasGeoLocation"
    [mapInstance]="map"
    [mapStyle]="mapBoxStyle"
    [displayMarker]="markersToDisplay"
    [queryFilters]="queryFilters"
    (editLayout)="editLayout($event)"
    (getLocation)="goToUserLocation()"
    (openResults)="openResults()"
    (runFilter)="runFilter($event)"
    (addressSelected)="onAddressSelected($event)"
    (toggleMarkersToDisplay)="onToggleMarkersToDisplay($event)"
    (markersFilterChanged)="onMarkersFilterChanged($event)"
    (clearFilter)="onClearFilters()"
  ></research-filters>

  <mat-drawer-container>
    <mat-drawer [mode]="drawerMode" [opened]="drawerOpened" [position]="'start'" #matDrawer>
      <router-outlet></router-outlet>
    </mat-drawer>

    <mat-drawer-content>
      <!-- Main -->
      <div class="main">
        <mat-progress-bar class="absolute z-10" *ngIf="loadingMarkers$ | async" mode="indeterminate"></mat-progress-bar>
        <div id="legend" style="display: none"></div>
        <div
          id="legend-deal-status"
          class="legend-deal-status"
          [class.top-16]="hasLayerSelected('vector', 'flood_zones')"
          *ngIf="markersToDisplay === 'Project' && dealStatusLegend?.length > 0"
          cdkDrag
        >
          <app-deal-status-legend [legendItems]="dealStatusLegend"></app-deal-status-legend>
        </div>
        <div id="legend-fema-flood" class="legend-fema-flood" *ngIf="hasLayerSelected('vector', 'flood_zones')" cdkDrag>
          <app-flood-map-legend></app-flood-map-legend>
        </div>

        <mgl-map
          [style]="mapBoxStyle"
          [zoom]="[zoom]"
          [minZoom]="4"
          [projection]="'mercator'"
          [center]="[center.longitude, center.latitude]"
          (mapLoad)="onMapLoaded($event)"
          (zoomEnd)="onZoomEnd()"
          (mapMouseOut)="onMapMouseOut()"
          (mapWheel)="onBoundingBoxChange()"
          (mapDragEnd)="onBoundingBoxChange()"
          [transformRequest]="onTransformMapRequest"
          (mapClick)="onSelectLatLng($event)"
          (moveEnd)="onMoveEnd()"
        >
          <ng-container *ngIf="filteredDealsGeoJSONData()">
            <mgl-geojson-source id="deals-geojson" [data]="filteredDealsGeoJSONData()" />
            <mgl-layer
              id="deal-properties-pin"
              type="circle"
              source="deals-geojson"
              [paint]="{
                'circle-color': ['get', 'hex_color'],
                'circle-radius': 8,
                'circle-stroke-width': 2,
                'circle-stroke-color': '#FFFFFF',
              }"
              (layerMouseMove)="onMarkerMouseMove($event)"
              (layerMouseLeave)="onMarkerMouseLeave()"
              (layerClick)="onDealLayerMarkerClick($event)"
            ></mgl-layer>
          </ng-container>

          <ng-container *ngIf="filteredPropertiesGeoJSONData()">
            <mgl-geojson-source id="properties-geojson" [data]="filteredPropertiesGeoJSONData()" />
            <mgl-layer
              id="properties-pin"
              type="circle"
              source="properties-geojson"
              [paint]="{
                'circle-color': '#6B7280',
                'circle-radius': 8,
                'circle-stroke-width': 2,
                'circle-stroke-color': '#FFFFFF',
              }"
              (layerMouseMove)="onMarkerMouseMove($event)"
              (layerMouseLeave)="onMarkerMouseLeave()"
              (layerClick)="onPropertyLayerMarkerClick($event)"
            ></mgl-layer>
          </ng-container>

          <mgl-image [id]="item.id" [url]="item.descriptionImage" *ngFor="let item of floodMapOverlayImages">
          </mgl-image>
          <mgl-control mglNavigation showZoom="true"></mgl-control>

          <ng-container *ngIf="center && !isNaN(center.latitude) && !isNaN(center.longitude)">
            <mgl-marker [lngLat]="[center.longitude, center.latitude]">
              <img src="assets/images/map/red-marker.png" style="width: 20px" />
            </mgl-marker>
          </ng-container>

          <ng-container *ngFor="let parcel of parcels">
            <ng-container *ngIf="parcel && !isNaN(parcel.latitude) && !isNaN(parcel.longitude)">
              <mgl-marker [lngLat]="[parcel.longitude, parcel.latitude]">
                <img src="assets/images/map/orange-dot.png" />
              </mgl-marker>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="geoData">
            <mgl-geojson-source id="heatmapSource" [data]="geoData"></mgl-geojson-source>
            <mgl-layer
              id="heatmapLayer"
              source="heatmapSource"
              type="fill"
              [paint]="{
                'fill-outline-color': 'white',
                'fill-opacity': 0.6,
                'fill-color': {
                  property: geoProperty,
                  stops: geoStops,
                },
              }"
            ></mgl-layer>
          </ng-container>

          <ng-container *ngIf="dealGeoData">
            <mgl-geojson-source id="dealGeoDataSource" [data]="dealGeoData"></mgl-geojson-source>
            <ng-container *ngFor="let marker of dealGeoData.features">
              <mgl-marker #myMarker [lngLat]="marker.geometry.coordinates"></mgl-marker>
              <mgl-popup [marker]="myMarker">
                <div class="flex flex-col max-w-80 w-full filter-article">
                  <div class="m-1">
                    <div class="mt-2">
                      <div class="flex flex-wrap items-left flex-col text-secondary my-1">
                        <div *ngFor="let property of marker?.properties | keyvalue">
                          <span class="font-semibold leading-tight">{{ property.key }}:</span>
                          {{ property.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mgl-popup>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="loadedParcels$ | async as bboxParcels">
            <mgl-marker *ngFor="let parcel of bboxParcels" [lngLat]="[parcel.parcel.longitude, parcel.parcel.latitude]">
              <div class="marker">
                <span
                  class="small"
                  [ngStyle]="{ background: lastHoveredRow?.parcel.id === parcel.parcel.id ? 'red' : '#3191f1' }"
                  ><!-- wip --></span
                >
              </div>
            </mgl-marker>
          </ng-container>

          <ng-container *ngFor="let layer of filterLayers(['fill'])">
            <mgl-geojson-source [id]="layer.id" [data]="layer.url"></mgl-geojson-source>
            <mgl-layer
              [id]="layer.id"
              [source]="layer.id"
              [type]="layer.type"
              [paint]="{
                'fill-color': 'black',
                'fill-opacity': 0.5,
              }"
            ></mgl-layer>
          </ng-container>

          <ng-container *ngFor="let layer of filterLayers(['vector'])">
            <mgl-vector-source
              type="vector"
              [id]="layer.id"
              [tiles]="[parceledTileServerUrl + '/app/api/tiles/' + layer.id + '/{z}/{x}/{y}']"
              [minzoom]="layer?.minZoom ?? 8"
            ></mgl-vector-source>
            <ng-container [ngSwitch]="layer.id">
              <ng-container *ngSwitchCase="'parcels'">
                <mgl-layer
                  [id]="layer.id + '-line'"
                  [source]="layer.id"
                  [sourceLayer]="layer.attribute"
                  type="line"
                  [layout]="{ visibility: parcelTilesVisible }"
                  [paint]="{
                    'line-color': '#006dff',
                    'line-width': 1,
                  }"
                ></mgl-layer>
                <mgl-layer
                  [id]="layer.id + '-fill'"
                  [source]="layer.id"
                  [sourceLayer]="layer.attribute"
                  type="fill"
                  [layout]="{ visibility: parcelTilesVisible }"
                  [paint]="{
                    'fill-color': 'rgba(0,108,253,0.24)',
                  }"
                  (layerMouseMove)="onLayerMouseMove($event)"
                  (layerMouseLeave)="onLayerMouseLeave()"
                  (layerClick)="onParcelClick($event)"
                ></mgl-layer>
              </ng-container>

              <ng-container *ngSwitchCase="'flood_zones'">
                <mgl-layer
                  [id]="layer.id + '-fill'"
                  [source]="layer.id"
                  [sourceLayer]="layer.attribute"
                  type="fill"
                  [layout]="{ visibility: 'visible' }"
                  [paint]="layerFlood"
                  (layerClick)="onFloodLayerClick($event)"
                  (layerMouseMove)="onLayerMouseMove($event)"
                  (layerMouseLeave)="onLayerMouseLeave()"
                ></mgl-layer>
              </ng-container>

              <ng-container *ngSwitchDefault>
                @if (layer?.layerType === 'CIRCLE') {
                  <mgl-layer
                    [id]="layer.id"
                    [source]="layer.id"
                    type="circle"
                    [sourceLayer]="layer.attribute"
                    [paint]="{
                      'circle-radius': 8,
                      'circle-color': '#FF0000',
                      'circle-stroke-width': 1,
                      'circle-stroke-color': '#FFFFFF',
                    }"
                    (layerMouseMove)="onLayerMouseMoveAdditional($event)"
                    (layerMouseLeave)="onLayerMouseLeave()"
                  ></mgl-layer>
                } @else {
                  <mgl-layer
                    [id]="layer.id"
                    [source]="layer.id"
                    type="line"
                    [sourceLayer]="layer.attribute"
                    [paint]="{
                      'line-color': '#6fa8f6',
                      'line-width': 1,
                    }"
                  ></mgl-layer>
                  <mgl-layer
                    [id]="layer.id + '-fill'"
                    [source]="layer.id"
                    [sourceLayer]="layer.attribute"
                    type="fill"
                    [paint]="{
                      'fill-color': 'rgba(0,108,253,0.24)',
                    }"
                    (layerMouseMove)="onLayerMouseMoveAdditional($event)"
                    (layerMouseLeave)="onLayerMouseLeave()"
                  ></mgl-layer>
                }
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngFor="let layer of filterLayers(['symbol', 'circle'])">
            <mgl-geojson-source [id]="layer.id" [data]="layer.url"></mgl-geojson-source>
            <mgl-layer
              [id]="layer.id"
              [source]="layer.id"
              [type]="layer.type"
              (layerClick)="onLayerClick($event, layer)"
              [paint]="{
                'circle-color': 'red',
              }"
            ></mgl-layer>
          </ng-container>

          <ng-container *ngFor="let layer of filterLayers(['raster'])">
            <mgl-raster-source id="layer.id" [tiles]="[layer.url]" [tileSize]="256"></mgl-raster-source>
            <mgl-layer
              id="layer.id"
              source="layer.id"
              sourceLayer="28"
              type="raster"
              [paint]="{ 'raster-opacity': 0.85 }"
            >
            </mgl-layer>
          </ng-container>

          <mgl-popup *ngIf="selectedLayerPoint?.properties" [lngLat]="selectedLayerPoint?.lngLat">
            <div class="flex flex-col max-w-80 w-full filter-article">
              <div class="m-1">
                <div class="mt-2">
                  <div class="flex flex-wrap items-left flex-col text-secondary my-1">
                    <div *ngFor="let property of selectedLayerPoint?.properties | keyvalue">
                      <span class="font-semibold leading-tight">{{ property.key }}:</span>
                      {{ property.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mgl-popup>
        </mgl-map>

        <div class="mgl-map-overlay-left" style="border: 1px solid; background-color: white; border-radius: 50%">
          <button class="lt-md:hidden" mat-icon-button (click)="toggleDrawer()">
            <mat-icon [svgIcon]="'double_arrow'"></mat-icon>
          </button>
        </div>
        <div class="mgl-map-overlay-parcel-details" *ngIf="selectedParcelFeature">
          <div class="flex flex-row" *ngFor="let item of selectedParcelFeature | keyvalue">
            <strong>{{ item.key | titlecase }}:&nbsp;</strong>
            <span>{{ item.value }}</span>
          </div>
        </div>
        @if (selectedMarkerLayer()) {
          <div
            class="mgl-map-overlay-marker-details"
            [ngStyle]="{
              top: selectedMarkerLayer().y + 'px',
              left: selectedMarkerLayer().x + 'px',
            }"
          >
            <p class="font-semibold px-3">{{ selectedMarkerLayer().title }}</p>
            <ts-divider spacing="sm" />
            <div class="flex flex-row gap-2 px-3">
              @for (col of selectedMarkerLayer().layout; track col) {
                <div class="flex flex-col justify-start items-start gap-2 text-sm">
                  @for (item of col; track item.value) {
                    <span>
                      <span class="font-semibold">{{ item?.label || '-' }}: </span><span>{{ item?.value || '-' }}</span>
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        }
        <div class="mgl-map-overlay__layer-selection">
          <ts-button
            #layerSelectionButton
            icon="ts_layer-group"
            [disabled]="loadingLayerOptions$ | async"
            [type]="(layerSelectionOverlay.isOpen | async) ? 'flat' : 'stroked'"
            [color]="(layerSelectionOverlay.isOpen | async) ? 'primary' : 'accent'"
            (click)="layerSelectionOverlay.open()"
          ></ts-button>
          <app-overlay-helper
            #layerSelectionOverlay
            [overlayOrigin]="layerSelectionButton"
            [position]="{ originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top' }"
          >
            <research-layers
              *ngIf="(loadingLayerOptions$ | async) === false"
              (selectedLayersChanged)="onSelectedLayersChanged($event)"
            ></research-layers>
          </app-overlay-helper>
        </div>
        <div class="mgl-map-overlay__view-toggle">
          <ng-container *ngIf="viewMode | async as mapViewMode">
            <button type="button" (click)="toggleMapViewMode(mapViewMode)">
              <ng-container *ngIf="mapViewMode === 'mapbox/satellite-streets-v12'; else streetMode">
                <img
                  alt="Toggle Map View Mode"
                  ngSrc="/assets/images/map/satellite.png"
                  width="64"
                  height="64"
                  priority
                />
                <p class="mgl-map-overlay__view-toggle__label">SATELLITE</p>
              </ng-container>
              <ng-template #streetMode>
                <img alt="Toggle Map View Mode" ngSrc="/assets/images/map/street.png" width="64" height="64" priority />
                <p class="mgl-map-overlay__view-toggle__label">STREET</p>
              </ng-template>
            </button>
          </ng-container>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
  <div class="table-container floaty animate__animated animate__slideInUp animate__faster" *ngIf="showParcelTable">
    <app-parcel-table
      [source]="loadedParcels$ | async"
      [isLoading]="isOwnerSearchLoading"
      (close)="closeTable()"
      (hoverRow)="onParcelTableHoverRow($event)"
    ></app-parcel-table>
  </div>
</div>

@if (pendingSearch()) {
  <div class="search-prompt" (click)="emitSearch()"><mat-icon>search</mat-icon> Search this area</div>
}
